import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ModalService } from 'projects/mariano-max/src/app/core/app-shared/public-api';
import { EcommerceGenericoService } from 'projects/mariano-max/src/app/core/ecommerce-generico/public-api';

@Component({
  selector: 'modal-arrepentimiento',
  templateUrl: './modal-arrepentimiento.component.html',
  styleUrls: ['./modal-arrepentimiento.component.scss']
})
export class ModalArrepentimientoComponent implements OnInit {
  formArrepentimiento: FormGroup;
  enviado: boolean = false;
  cargando: boolean = false;

  constructor(
    private modal: ModalService,
    private genServ: EcommerceGenericoService,
    private fb: FormBuilder
  ) {
    this.formArrepentimiento = this.fb.group({
      nombre: ['', Validators.required],
      email: ['', [Validators.required, Validators.email]],
      pedido: ['', Validators.required],
      mensaje: ['']
    });
  }

  ngOnInit(): void {
  }

  cerrar() {
    this.modal.close('modal-arrepentimiento');
  }

  enviar() {
    if (this.formArrepentimiento.valid) {
      this.cargando = true;
      this.genServ.enviarArrepentimiento(this.formArrepentimiento.value).subscribe({
        next: (res) => {
          this.cargando = false;
          this.enviado = true;
        },
        error: (err) => {
          this.cargando = false;
          console.error("Error enviando arrepentimiento", err);
          // Opcional: mostrar error al usuario
        }
      });
    }
  }

  get mailSoporte() {
    return this.genServ.getmailAtencionAlCliente();
  }
}
